import * as Safe from "safe-portals";

export interface CampaignTargetProviderDef<T> {
  /** Prefix with plugin_name: */
  provider_unique_id: string;
  label: string;
  /**
   * Custom properties when editing this targeting method from action type edit components.
   *
   * This is versioned since it is a plugin data structure within a plugin data structure
   * (action.config.my_plugins_target_provider_config) and therefore migrating this structure
   * would require knowing where all plugins have used it -- so instead the migrations
   * are provided on the Safe.Versioned<T> serializer/deserializer.
   */
  config_type: Safe.Versioned<T>;
}

export const CampaignTargetProviderConfigSerializer = Safe.obj({
  provider_unique_id: Safe.str,
  config: Safe.raw, // serialized specific type T of campaign provider
});

export type CampaignTargetProviderConfig = Safe.TypeIn<typeof CampaignTargetProviderConfigSerializer>;

export function makeCampaignTargetProviderDef<T>(def: CampaignTargetProviderDef<T>) {
  return def;
}
